import axios from 'axios'
import { getApiBaseUrl } from '../utils/api'

/**
 * GET /company/franchise/usage is authenticated with the company's X-API-KEY
 * (not the dashboard session's Bearer token), so this deliberately does NOT
 * use the shared `api` axios instance from utils/api.js - that instance
 * attaches the session Bearer token and, on any 401, force-logs-out the
 * dashboard user. A missing/invalid X-API-KEY here has nothing to do with
 * the dashboard session being invalid, so it must fail locally instead.
 *
 * Concurrent callers share one in-flight request: the dashboard's login alert
 * (CompanyDashboardPage) and FranchiseUsageCard both ask for usage as soon as
 * the API key loads, and two parallel cache misses would double the backend
 * work. Once it settles, the next call (e.g. the card's retry) hits the API again.
 */
const inFlight = new Map()

export const franchiseService = {
  getUsage: (apiKey) => {
    if (!apiKey) {
      return Promise.reject(new Error('API key da empresa ainda não carregada'))
    }
    if (!inFlight.has(apiKey)) {
      const request = axios
        .get(`${getApiBaseUrl()}/company/franchise/usage`, {
          headers: { 'X-API-KEY': apiKey },
          timeout: 15000,
        })
        .then((response) => response.data)
        .finally(() => inFlight.delete(apiKey))
      inFlight.set(apiKey, request)
    }
    return inFlight.get(apiKey)
  },
}
